module.exports = __webpack_public_path__ + "07_hair_silver.53d2bddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/07_hair_silver.png
// module id = q014
// module chunks = 0